import { useEffect, useRef } from "react";

const AutoScroll = ({ children }: { children: React.ReactNode }) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const scroll = () => {
      if (scrollRef.current) {
        scrollRef.current.scrollLeft += 1; // Adjust speed as needed
        if (scrollRef.current.scrollLeft >= scrollRef.current.scrollWidth / 2) {
          scrollRef.current.scrollLeft = 0; // Reset to prevent jumping
        }
      }
    };
    const interval = setInterval(scroll, 20); // Adjust speed as needed
    return () => clearInterval(interval);
  }, []);

  return (
    <div ref={scrollRef} className="flex w-full overflow-hidden whitespace-nowrap">
      {children}
    </div>
  );
};

export default AutoScroll;
